import type {
  AuthenticatedSession,
  AuthorizedSession,
  AuthorizedSessionJSON,
} from '@mntn-dev/auth-types'

import { createPermissions } from './permissions/create-permissions.ts'
import type { UserPrincipalOrSystemUser } from './system-session.ts'

export const authorizeSessionFromUser = (
  session: AuthenticatedSession | AuthorizedSession,
  user: UserPrincipalOrSystemUser
): AuthorizedSession => {
  const authorizedSession: AuthorizedSession = {
    ...session,
    principal: {
      ...session.principal,
      user,
      ...createPermissions({ organizationType: user.organizationType }),
    },
  } as const

  return authorizedSession
}

export const rehydrateAuthorizedSession = (
  session: AuthorizedSession | AuthorizedSessionJSON
): AuthorizedSession => {
  const authorizedSession: AuthorizedSession = {
    ...session,
    principal: {
      ...session.principal,
      ...createPermissions({
        organizationType: session.principal.user.organizationType,
      }),
    },
  } as const

  return authorizedSession
}
